import React from 'react';
import PropTypes from 'prop-types';
import {Icon, IconButton} from "@material-ui/core";
import ScriptType from "../../../../../../../../../Utils/Form/FormDynamic/Fields/ScriptType";

const CustomCss = ({setValue, values, path}) => {
    return (
        <div>
            <span>Custom Css</span>
            <IconButton>
                <Icon>
                    code
                </Icon>
            </IconButton>
            <div style={{padding: 8}}>
                <ScriptType
                    labelStyles={{width: 0}}
                    fieldStyles={{height: 43, width: '100%', fullWidth: true}}
                    values={values}
                    field={{
                        inputMode: 'inline',
                        path: `${path}`,
                        syntaxHighlight: "css"
                    }}
                    setValue={setValue}
                />
            </div>
        </div>
    );
};

CustomCss.propTypes = {
    setValue: PropTypes.func,
    values: PropTypes.object
};

export default CustomCss;